export default "__VITE_ASSET__Blbc3$yg__"